import React from 'react';
import { AlertTriangleIcon, ClockIcon } from 'lucide-react';
import { mockTickets } from '../data/mockData';
export function SLAPriorityQueue() {
  // Filter for critical/high or overdue tickets
  const priorityTickets = mockTickets.filter(t => t.priority === 'Critical' || t.priority === 'High' || t.status === 'Overdue').sort((a, b) => {
    if (a.status === 'Overdue') return -1;
    if (b.status === 'Overdue') return 1;
    if (a.priority === 'Critical') return -1;
    if (b.priority === 'Critical') return 1;
    return 0;
  }).slice(0, 5);
  return <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 h-full" data-id="element-63">
      <div className="flex items-center justify-between mb-6" data-id="element-64">
        <h2 className="text-lg font-bold text-gray-900 flex items-center" data-id="element-65">
          <AlertTriangleIcon className="w-5 h-5 text-red-500 mr-2" data-id="element-66" />
          SLA Monitor & Priority Queue
        </h2>
        <span className="bg-red-100 text-red-700 text-xs font-bold px-2.5 py-1 rounded-full" data-id="element-67">
          {priorityTickets.length} Action Required
        </span>
      </div>

      <div className="space-y-4" data-id="element-68">
        {priorityTickets.map(ticket => {
        const isBreached = ticket.status === 'Overdue';
        const isAtRisk = ticket.priority === 'Critical' && ticket.status === 'Open';
        return <div key={ticket.id} className={`p-4 rounded-lg border ${isBreached ? 'border-red-200 bg-red-50' : 'border-gray-100 bg-white'}`} data-id="element-69">
              <div className="flex justify-between items-start mb-2" data-id="element-70">
                <div className="flex items-center space-x-2" data-id="element-71">
                  {isBreached && <span className="w-2 h-2 rounded-full bg-red-600 animate-pulse" data-id="element-72"></span>}
                  {isAtRisk && <span className="w-2 h-2 rounded-full bg-amber-500" data-id="element-73"></span>}
                  <span className="font-medium text-sm text-gray-900" data-id="element-74">
                    {ticket.id}
                  </span>
                  <span className={`text-xs px-2 py-0.5 rounded border font-medium ${ticket.priority === 'Critical' ? 'bg-red-100 text-red-700 border-red-200' : 'bg-orange-100 text-orange-700 border-orange-200'}`} data-id="element-75">
                    {ticket.priority}
                  </span>
                </div>
                <span className="text-xs text-gray-500 flex items-center" data-id="element-76">
                  <ClockIcon className="w-3 h-3 mr-1" data-id="element-77" />
                  {ticket.firstResponseTime}m elapsed
                </span>
              </div>

              <p className="text-sm text-gray-800 font-medium mb-3 truncate" title={ticket.subject} data-id="element-78">
                {ticket.subject}
              </p>

              <div className="space-y-2" data-id="element-79">
                <div data-id="element-80">
                  <div className="flex justify-between text-xs mb-1" data-id="element-81">
                    <span className="text-gray-500" data-id="element-82">
                      First Response SLA (1hr)
                    </span>
                    <span className={ticket.firstResponseTime > 60 ? 'text-red-600 font-medium' : 'text-gray-700'} data-id="element-83">
                      {ticket.firstResponseTime > 60 ? 'Breached' : 'On Track'}
                    </span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-1.5" data-id="element-84">
                    <div className={`h-1.5 rounded-full ${ticket.firstResponseTime > 60 ? 'bg-red-500' : ticket.firstResponseTime > 45 ? 'bg-amber-500' : 'bg-green-500'}`} style={{
                  width: `${Math.min(ticket.firstResponseTime / 60 * 100, 100)}%`
                }} data-id="element-85"></div>
                  </div>
                </div>
              </div>
            </div>;
      })}
      </div>
    </div>;
}